import { render, staticRenderFns } from "./EditStorageQueryProductChannel.vue?vue&type=template&id=8dbd41f4&"
import script from "./EditStorageQueryProductChannel.vue?vue&type=script&lang=ts&"
export * from "./EditStorageQueryProductChannel.vue?vue&type=script&lang=ts&"
import style0 from "./EditStorageQueryProductChannel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditStorageQueryProductChannel.vue"
export default component.exports